export default {
  naver: null,
  kakao: null,
  facebook: null,
  user: {
    memberId: null,
    oauthUid: null,
    provider: null,
  },
};
